import gql from "graphql-tag";
import {responseField} from "../../../../base.graphql";
import {paginationFields} from "../../geographical-zone/geographical-zone.graphql";

export const regionGqlFields = `
name
code
uniqueId
id
`;


export const ALL_REGIONS = gql`
query GetAllRegions {
  getAllRegions {
    response {
      ${responseField}
    }
    data {
      ${regionGqlFields}
    }
  }
}
`
